import { TLCLogger } from "../../../js/lib/logger";
import { LandingPageUtil } from "./LandingPageUtil";
import { ListPreloader } from "./ListPreloader";
import { SliderPage2 } from "./SliderPage2";

export class ListCarousel {
  constructor(listIndex, options, isVisible) {
    //TODO if we leave this list, pause the pre-loader, or give priority to the current list and subsequent lists first

    this.listItems;
    this.listIndex = listIndex;
    this.nextEnabled = false;
    this.loader; //TODO
    this.listPages = [];

    //this.currentPageIndex = 0;//TODO change this.current to this.currentPageIndex
    this.current = 0;

    //set dynamically based on page size
    this.pageWidth = options.pageWidth;
    this.pageLength = options.pageLength;
    this.options = options;
    this.loaded = false;

    var _this = this;

    this.init(isVisible);
  }
  init(isVisible) {
    var listPage = this.createListPage(0, isVisible); //init a visible SliderPage
  }
  setResourceList(resourceList, callback) {
    this.listItems = resourceList;
    this.addPage(0, callback);
  }
  isNextEnabled() {
    return this.getCurrentPage().isLoaded();
  }
  isPrevEnabled() {
    if (this.current === 0) {
      if (this.loaded === true) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  slidePages(prev, direction, next, position, callback) {
    var nextPage = this.getListPage(next),
      _this = this,
      startPosition = position,
      endPosition,
      prevRemainVisible = false;

    if (nextPage === undefined) {
      nextPage = this.addPage(next); //TODO use the callback instead?
    }
    var pageCount = nextPage.getPageCount();
    var prevPage = this.getListPage(prev);
    var prevPageCount = prevPage.getPageCount();

    if (this.listPages.length > 2) {
      if (pageCount < this.pageLength) {
        if (this.isLastPage(next)) {
          if (prev === 0) {
            //pressing back from the first page
            var prevWrapPosition = LandingPageUtil.getPrevWrapPosition(
              pageCount,
              this.options.pageWidth
            );
            direction = prevWrapPosition.firstPage.end;
            startPosition = prevWrapPosition.prevPage.start;
            endPosition = prevWrapPosition.prevPage.end;
            prevRemainVisible = true;
          } else {
            var wrapPosition = LandingPageUtil.getWrapPosition(
              pageCount,
              this.options.pageWidth
            );
            let firstPage = this.getFirstPage();
            firstPage.animateIn(wrapPosition.start, null, wrapPosition.end);
          }
        }
      } else if (prevPageCount < this.pageLength) {
        if (this.isLastPage(prev) && next !== 0) {
          //pressing back from the last partial page
          let firstPageStart = LandingPageUtil.getAdjustedDirection(
              prevPageCount,
              this.options.pageWidth
            ),
            firstPage = this.getFirstPage();

          firstPage.animateOut(this.options.pageWidth + firstPageStart); //+start position
          direction = this.options.pageWidth;
        }
      }
    }

    prevPage.animateOut(direction, null, prevRemainVisible);
    nextPage.animateIn(
      startPosition,
      function () {
        if (callback) {
          callback();
        }
      },
      endPosition
    );
  }
  onResize(options) {
    this.pageWidth = options.pageWidth;
    this.pageLength = options.pageLength;
    this.options = options;
    $.each(this.listPages, function (j, listPage) {
      //resize jacket, margin, and image
      listPage.resizeJackets(options);
    });
  }
  getLoadCounts() {
    var loadCounts = this.loader.getLoadCounts();
    if (loadCounts.doneLoading === true) {
      TLCLogger.log("loaded", loadCounts);
    }
    return loadCounts;
  }
  goToNextPage(callback) {
    var prev = this.current;
    var next = this.current + 1;

    var loadCounts = this.getLoadCounts();
    this.pages = Math.ceil(loadCounts.possibleTotal / this.pageLength);

    if (
      next !== this.pages &&
      loadCounts.possibleRemaining > 0 &&
      loadCounts.available === 0
    ) {
      //this should be unreachable
    }
    next = this.pages === next ? 0 : next;
    this.current = next;
    var position = this.pageWidth * 1;
    var direction = this.getDirection(prev) * -1;
    this.slidePages(prev, direction, next, position, callback); //TODO if next does not exist, wrap
  }
  getDirection(pageIndex) {
    var pageCount = this.getListPage(pageIndex).getPageCount(),
      direction = this.pageWidth * 1;
    if (this.listPages.length <= 2) {
      return direction;
    } else if (pageCount < this.pageLength) {
      return LandingPageUtil.getAdjustedDirection(pageCount, this.pageWidth);
    }
    return direction;
  }
  goToPrevPage(callback) {
    var prev = this.current;
    var next = this.current - 1;
    if (next === -1) {
      next = this.pages - 1;
    }
    this.current = next;
    var position = -this.pageWidth * 1;
    var direction = this.getDirection(prev);
    this.slidePages(prev, direction, next, position, callback);
  }
  getListPage(pageIndex) {
    var listPage = this.listPages[pageIndex];
    if (listPage === undefined) {
      listPage = this.addPage(pageIndex);
      //TODO re-check this.pages?
    }
    return listPage;
  }
  setListPage(pageIndex, listPage) {
    this.listPages[pageIndex] = listPage;
  }
  getCurrentPage() {
    return this.getListPage(this.current);
  }
  getFirstPage(isVisible) {
    return this.getListPage(0);
  }
  createListPage(pageIndex, isVisible) {
    var isFirst = pageIndex === 0;
    var listPage = new SliderPage2(
      this.getPageId(pageIndex),
      this.options,
      isVisible,
      isFirst
    );
    this.setListPage(pageIndex, listPage);
    return listPage;
  }
  destroy() {
    this.listPages.forEach((page) => {
      page.destroy();
    })
    this.listPages = [];
    this.loader?.destroy();
    this.loader = null;
  }
  updatePageCount() {
    var loadCounts = this.getLoadCounts();
    if (loadCounts.doneLoading === true) {
      this.loaded = true;
    }
    this.pages = Math.ceil(loadCounts.possibleTotal / this.pageLength);
  }
  addPage(pageIndex, callback) {
    var preLoader = this.getListPreLoader(),
      listPage = this.listPages[pageIndex];
    this.updatePageCount();
    if (listPage === undefined) {
      listPage = this.createListPage(pageIndex);
    }
    preLoader.getPage(
      this.pageLength,
      this.onGetPreloadedPage(listPage, callback)
    );
    return listPage;
  }
  addNextPage() {
    var next = this.current + 1;
    next = this.pages === next ? 0 : next; //TODO is this.pages set properly here?
    if ($("#" + this.getPageId(next)).length === 0) {
      this.addPage(next);
    }
  }
  isNotPageable() {
    return this.pages < 2;
  }
  getPageId(pageIndex) {
    return "page_" + this.listIndex + "_" + pageIndex;
  }
  isLastPage(pageIndex) {
    pageIndex = pageIndex === undefined ? this.current : pageIndex;
    var next = pageIndex + 1,
      loadCounts = this.getLoadCounts();
    //TODO if loadCounts.doneLoading === true
    //this.pages = this.listPages.length;
    //and Math.ceil(loadCounts.possibleTotal/this.pageLength) should === this.listPages.length
    //else
    this.pages = Math.ceil(loadCounts.possibleTotal / this.pageLength);
    return this.pages === next;
  }
  onGetPreloadedPage(listPage, callback) {
    var _this = this;
    return function (resources) {
      listPage.load(resources); // loading the page with 0 resources will remove the empty jackets
      if (resources.length === 0 && _this.listPages.length > 1) {
        _this.listPages.pop(); // remove the page and advance
        _this.goToNextPage(callback);
        return;
      }

      if (callback) {
        callback(resources);
      }
    };
  }
  animateFirstPageIfWrapping(prevPage, isDown) {
    var firstPage = this.getFirstPage();
    if (
      firstPage.getVisible() &&
      firstPage.getPageId() !== prevPage.getPageId() &&
      this.listPages.length > 2
    ) {
      if (isDown) {
        firstPage.animateDown();
      } else {
        firstPage.animateUp();
      }
    }
  }
  animateDownOut(callback) {
    var prevPage = this.getCurrentPage();
    this.animateFirstPageIfWrapping(prevPage, true);
    prevPage.animateDown(function () {
      if (callback) {
        callback();
      }
    });
  }
  animateUpIn(callback) {
    this.current = 0; //before
    var nextPage = this.getFirstPage();
    nextPage.animateUp(function () {
      if (callback) {
        callback();
      }
    });
  }
  animateUpOut(callback) {
    var prevPage = this.getCurrentPage();
    this.animateFirstPageIfWrapping(prevPage, false);
    prevPage.animateUp(function () {
      if (callback) {
        callback();
      }
    });
  }
  animateDownIn(callback) {
    this.current = 0; //before
    var nextPage = this.getFirstPage();
    nextPage.animateDown(function () {
      if (callback) {
        callback();
      }
    });
  }
  getListPreLoader() {
    if (!this.loader) {
      //TODO listItems might not be set
      this.loader = new ListPreloader({
        list: this.listItems,
      });
    }
    return this.loader;
  }
}
